import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'app-preloader',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <table width="100%">
            <tr>
                <td [style.height]="height + 'px'" style="vertical-align: middle; width: 100%; text-align: center">
                    <lib-icon class="icon-color-green" [size]="height >= 70 ? 70 : height"
                              type="@animated/loading"></lib-icon>
                    <div>
                        <ng-content></ng-content>
                    </div>
                </td>
            </tr>
        </table>
    `
})
export class PreloaderComponent {
    @Input() height = 100;
}
